/**
 * 手机号工具函数（前后端共用，纯函数无服务端依赖）
 */

/** 虚拟运营商（移动转售业务）号段：162/165/167/170/171 */
const VIRTUAL_OPERATOR_PREFIXES = ['162', '165', '167', '170', '171'];

export const VIRTUAL_OPERATOR_MESSAGE = '虚拟运营商号码暂不支持注册，请使用三大运营商手机号';

/** 校验手机号格式（中国大陆 11 位） */
export function isValidPhone(phone: string): boolean {
  return /^1[3-9]\d{9}$/.test(phone);
}

/** 判断是否为虚拟运营商号段（162/165/167/170/171） */
export function isVirtualOperatorPhone(phone: string): boolean {
  return VIRTUAL_OPERATOR_PREFIXES.some((p) => phone.startsWith(p));
}
